module.exports = __webpack_public_path__ + "static/media/snow_white.114f627c.png";